import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DateService } from '../core/date.service';

@Pipe({
  name: 'customerDate'
})
export class CustomerDatePipe extends DatePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) locale: string, private dateService : DateService){
    super(locale);
  }

  transform(value: any, ...args: any[]) : any{
    return super.transform(value, this.dateService.defaultDateFormat);
  }
}
